<div [ngSwitch]="formControlType">
    <div *ngSwitchCase="FormControlTypeEnum.Checkbox">
        <div class="form-check form-check-inline" *ngFor="let customerCategory of customerCategories">
            <label class="form-check-label custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" value="{{ customerCategory.id }}"
                       (change)="onCustomerCategoryChanged(customerCategory)">
                <span class="custom-control-indicator"></span>
                <span class="custom-control-description">{{ customerCategory.name }}</span>
            </label>
        </div>
    </div>
    <div *ngSwitchCase="FormControlTypeEnum.Select">
        <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown" *ngIf="selectedCategory">
            <button class="btn btn-sm btn-primary capitalize" id="dropdownManual" ngbDropdownToggle type="button">
                {{ selectedCategory.name }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownManual">
                <button (click)="onCustomerCategoryChanged(customerCategory)"
                        type="button"
                        class="dropdown-item capitalize"
                        *ngFor="let customerCategory of customerCategories">
                    {{ customerCategory.name }}
                </button>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/customer-categories/customer-categories.component.html